// Business Filters Component
// Feature: 005-business-administration

import { useTranslation } from 'react-i18next';
import type { BusinessStatus } from '@/types/businessAdmin';

interface BusinessFiltersProps {
  statusFilter: BusinessStatus | 'all';
  onStatusFilterChange: (status: BusinessStatus | 'all') => void;
}

export function BusinessFilters({ statusFilter, onStatusFilterChange }: BusinessFiltersProps) {
  const { t } = useTranslation('businessAdmin');

  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      <div className="flex-1">
        <label htmlFor="status-filter" className="block text-sm font-medium text-neutral-700 mb-2">
          {t('filters.status')}
        </label>
        <select
          id="status-filter"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value as BusinessStatus | 'all')}
          className="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        >
          <option value="all">{t('filters.all')}</option>
          <option value="active">{t('filters.active')}</option>
          <option value="disabled">{t('filters.disabled')}</option>
          <option value="awaiting_moderation">{t('filters.awaiting_moderation')}</option>
        </select>
      </div>
    </div>
  );
}
